import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";

import { LocalizationService } from "@app/core/services/localization.service";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "under-ui-language-switcher",
  templateUrl: "./language-switcher.component.html",
  styleUrl: "./language-switcher.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule, TranslatePipe],
})
export class LanguageSwitcherComponent {
  private readonly localizationService = inject(LocalizationService);

  protected readonly languages$ = this.localizationService.languages$;
  protected readonly currentLanguage$ = this.localizationService.language$;

  onSelectLanguage(code: string, currentLang: string | null): void {
    if (code === currentLang) {
      return;
    }

    this.localizationService.setLang(code);
    window.location.reload();
  }
}
